import React from "react"
import NavBar from "../NavBar"
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormLabel'
import FormLabel from '@material-ui/core/FormLabel'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import {connect} from 'react-redux'
import { I18n } from 'react-redux-i18n'

import {setHomePreference} from '../../actions/settingsActions'


const styles = theme => ({
  formControl: {
   margin: theme.spacing.unit * 3,
   border:"0"
 },
})

class Settings extends React.Component {
  onHomePreferenceChanged = (e) => {
    this.props.dispatch(setHomePreference(e.target.value))
  }

  render() {
    const { classes } = this.props
    return (
      <div>
        <NavBar/>
          <Grid container justify="center">
            <Grid item md={6}>
              <FormControl component="fieldset" className={classes.formControl}>
                <FormLabel component="legend">{I18n.t('settings.homepref')}</FormLabel>
                <RadioGroup
                  aria-label="{I18n.t('settings.homepref')}"
                  name="homepref"
                  className={classes.group}
                  value={this.props.settings.homePreference}
                  onChange={this.onHomePreferenceChanged}
                >
                  <FormControlLabel value="m" control={<Radio />} label={I18n.t('global.month')} />
                  <FormControlLabel value="w" control={<Radio />} label={I18n.t('global.week')} />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch
})

const mapStateToProps = (state) => ({
  settings: state.settings
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Settings))



// WEBPACK FOOTER //
// ./src/js/components/pages/Settings.js